import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateSageHrConfiguration } from '@app/models/integrations/sage-hr/create-sage-hr-configuration.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SagehrApiService {

  private readonly baseUrl = 'api/sage-hr';

    constructor(private readonly http: HttpClient) { }

    testSageHrCredentials(createSageHrCredentials: CreateSageHrConfiguration): Observable<void> {
        const url = `${this.baseUrl}/test-credentials`;
        return this.http.post<void>(url, createSageHrCredentials);
    }

    startManualSync(): Observable<void> {
        const url = `${this.baseUrl}/sync`;
        return this.http.get<void>(url);
    }

    testSyncErrorEvent(): Observable<void> {
      const url = `${this.baseUrl}/test/error`;
      return this.http.get<void>(url);
  }
}
